import React from 'react'
import { Telemetry } from '~/Services/Telemetry'

interface Props {
  children: React.ReactNode
}
interface State {
  hasError: boolean
}

/**
 * [MVP Observability] Bắt lỗi render của React (window.onerror không bắt được lỗi trong render tree).
 * Gửi telemetry rồi hiển thị fallback tối giản.
 */
export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    Telemetry.error({
      message: error.message,
      stack: `${error.stack || ''}\nComponentStack:${info.componentStack || ''}`,
    })
  }

  render() {
    if (this.state.hasError) {
      return <div style={{ padding: 24 }}>Đã xảy ra lỗi. Vui lòng tải lại trang.</div>
    }
    return this.props.children
  }
}
